// @ts-nocheck

import {
  makeType
} from "./types"

// console.log(`makeType:`, makeType);

import {
  flatten
} from "./functions"

// const RELEASE = true;
const RELEASE = false

const proto = {
  name: "",

  silent: true,
  // debug: false,
  prependArgs(args) {
    let name = ""
    if (this.name) {
      name = `${this.name}:`
    } else if (this.caller) {
      name = `${this.caller.name}:`
    }

    args = flatten(args)
    if (typeof args[0] === "string") {
      args[0] = `${name} ${args[0]}`
    } else {
      args = [name].concat(args)
    }
    return args
  },

  emitMsg(type, ...args) {
    if (!RELEASE) {
      args = this.prependArgs(args)
      switch (type) {
        case "trace":
          console.trace(...args)
          // console.info(...args);
          break
        case "debug":
        case "info":
          console.info(...args)
          break
        case "error":
          console.error(...args)
          break
        case "warn":
          console.warn(...args)
          break
      }
    }
  },

  enable() {
    this.silent = false
  },

  disable() {
    this.silent = true
  },

  trace(...args) {
    if (!this.silent) {
      this.emitMsg("trace", ...args)
    }
  },

  debug(...args) {
    if (!this.silent) {
      this.emitMsg("debug", ...args)
    }
  },

  error(...args) {
    this.emitMsg("error", ...args)
  },

  info(...args) {
    if (!this.silent) {
      this.emitMsg("info", ...args)
    }
  },

  warn(...args) {
    this.emitMsg("warn", ...args)
  }
}

const Log = makeType(proto)

export function initLog() {
  this.log = new Log(this)
  // this.log = new Log()
  this.log.name = this.name
}

// export const initLog2 = sup =>
//     class extends sup {
//         initLog() {
//             this.log = new Log(this);
//             this.log.name = this.name;
//         }
//     };

export default Log